import { Link } from 'react-router-dom';
import { getFeaturedArticles, formatDate, getCategoryBySlug } from '@/lib/content';
import { stats } from '@/mocks/site';

export default function HeroSection() {
  const cover = getFeaturedArticles(1)[0];
  const coverCategory = cover ? getCategoryBySlug(cover.categorySlug) : undefined;

  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20moody%20editorial%20workspace%20with%20scattered%20documents%20and%20a%20magnifying%20glass%20on%20aged%20paper%2C%20red%20thread%20connecting%20photos%20on%20a%20corkboard%2C%20warm%20amber%20desk%20lamp%20glow%2C%20cinematic%20investigative%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=1000&seq=hero-zhijing-01&orientation=landscape"
        alt="职镜观察编辑部桌面，散落的资料与放大镜，象征对公开信息的逐条核对"
        title="职镜观察 - 职场内幕与劳动权益信息平台"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-45"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/90 via-foreground-950/75 to-foreground-950/55" />

      <div className="relative mx-auto grid max-w-content gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-12 lg:gap-14 lg:py-28">
        <div className="animate-rise lg:col-span-7">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3.5 py-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-400" />
            <span className="font-label text-xs tracking-[0.2em] text-primary-100">
              2026 · 第 34 期观察
            </span>
          </div>

          <h1 className="font-heading text-3xl font-black leading-[1.25] text-background-50 md:text-5xl md:leading-[1.2]">
            在决定之前，
            <br />
            先看清一家公司真实的样子
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            我们围绕运营内幕、管理层背景、员工爆料、办公环境、裁员动向与薪资纠纷，
            把分散的公开线索整理成可读的观察记录，让求职与维权都少一点信息差。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/insight"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-center font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览全部观察
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md border border-background-300/40 px-6 py-3.5 text-center font-label text-sm font-medium text-background-100 transition-colors hover:bg-background-50/10"
            >
              我有线索要投稿
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-6 border-t border-background-50/15 pt-7 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-xl font-bold text-accent-300 md:text-2xl">{item.value}</dt>
                <dd className="mt-1 font-label text-xs text-background-300">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {cover && (
          <div className="animate-rise lg:col-span-5">
            <article className="overflow-hidden rounded-lg border border-background-50/15 bg-background-50">
              <div className="flex items-center justify-between gap-3 bg-primary-700 px-4 py-2.5">
                <span className="font-label text-xs tracking-[0.2em] text-primary-50">本期封面观察</span>
                <span className="font-label text-xs text-primary-100">{cover.readMinutes} 分钟</span>
              </div>
              <Link to={`/insight/${cover.id}`} className="block h-44 w-full overflow-hidden md:h-52">
                <img
                  src={cover.cover}
                  alt={cover.title}
                  title={`${cover.title} - ${coverCategory?.name ?? '职场观察'}`}
                  className="h-full w-full object-cover object-top"
                />
              </Link>
              <div className="p-5">
                <div className="mb-2 flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs text-accent-900">
                    {coverCategory?.name ?? '观察'}
                  </span>
                  <span className="font-label text-xs text-foreground-500">{formatDate(cover.date)}</span>
                </div>
                <h2 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                  <Link to={`/insight/${cover.id}`} className="transition-colors hover:text-primary-600">
                    {cover.title}
                  </Link>
                </h2>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{cover.excerpt}</p>
                <Link
                  to={`/insight/${cover.id}`}
                  className="mt-4 inline-flex items-center gap-1.5 font-label text-sm font-medium text-primary-700 transition-colors hover:text-primary-500"
                >
                  阅读全文
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}